import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import { createTheme, ThemeProvider } from '@mui/material/styles';


function Elixhauser({elixhauser}) {
    const getMuiTheme = () => createTheme({
        components: {
            MuiTableContainer:{
                styleOverrides:{
                    root: {
                        // border:'1px solid #ccc',
                        borderRadius: '5px',
                        fontFamily: 'Open Sans'
                    }
                }
            },
            MuiTableCell:{
                styleOverrides:{
                  root: {
                    lineHeight:'15px',
                    fontFamily: 'Open Sans'
                  }
                }
              },
        }
    })

  return (
    <div style={{width:'100%'}} >
        <ThemeProvider theme={getMuiTheme()}>
            <TableContainer sx={{
                maxHeight:  220, //elixhauser ? 220 : 50,
                borderRadius: 2,
                border:'1px solid #CCC',
                "& .MuiTableCell-root": {
                    border: '1px solid #f3f3f3'
                },
                "&::-webkit-scrollbar-track-piece:start": {
                    background: "transparent",
                    marginTop: "0px"
                },
                "&::-webkit-scrollbar": {
                    width: 6,
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "white"
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: 2
                }
            }}>
                    <Table stickyHeader size="small"
                        sx={{
                            borderCollapse: "collapse",
                            borderStyle: "hidden",
                            "& td": {
                                border:'1px solid #CCC'
                            }
                        }}>
                        <TableHead sx={{
                            "& th": {
                            backgroundColor: "#def1fc",
                            color: "black",
                            fontWeight:600,
                            },
                            "& th:hover": {
                            backgroundColor: "#c9e8fa",
                            }
                        }}>
                            <TableRow>
                                <TableCell>
                                    Elixhauser List
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        
                        <TableBody >
                            {elixhauser && elixhauser.map((el, index)=>{
                                return <TableRow key={index}>
                                            <TableCell>
                                                {el}
                                            </TableCell>
                                        </TableRow>
                            })}
                            {!elixhauser && 
                                    <TableRow>
                                        <TableCell>
                                          No data to display
                                        </TableCell>
                                    </TableRow>
                            }
                            
                         </TableBody>
                    </Table>
            </TableContainer>
        </ThemeProvider>
    </div>
  )
}

export default Elixhauser